// extracted by mini-css-extract-plugin
export default {"back_curtain":"backCurtain_back_curtain__HWlza","back_curtain_active":"backCurtain_back_curtain_active__SN7RW"};